// ============================================================
// Carrega o OTel RUM só com consentimento de "analytics" e depois
// que a página terminou de carregar, para não pesar no LCP.
// ============================================================

const CONSENT_KEY = "aroan-cookie-consent";
/** Disparado pelo CookieConsent quando o visitante aceita cookies de analytics. */
export const ANALYTICS_CONSENT_EVENT = "aroan:analytics-consent";

function hasAnalyticsConsent(): boolean {
  try {
    return JSON.parse(localStorage.getItem(CONSENT_KEY) ?? "null")?.analytics === true;
  } catch {
    return false;
  }
}

let started = false;
function start() {
  if (started) return;
  started = true;
  const load = () => void import("./instrumentation");
  if ("requestIdleCallback" in window) requestIdleCallback(load, { timeout: 5000 });
  else setTimeout(load, 2000);
}

export function initOtel() {
  // Em produção o coletor precisa de HTTPS (VITE_OTEL_ENDPOINT); sem ele, o navegador bloquearia o envio.
  if (import.meta.env.PROD && !import.meta.env.VITE_OTEL_ENDPOINT) return;

  if (hasAnalyticsConsent()) {
    if (document.readyState === "complete") start();
    else window.addEventListener("load", start, { once: true });
  }
  window.addEventListener(ANALYTICS_CONSENT_EVENT, start, { once: true });
}
